export const API_URL: string = 'https://api.themoviedb.org/3'
